// extracted by mini-css-extract-plugin
export default {"Logo":"Logo_Logo__TTsRT","big":"Logo_big__zqN21"};